import { useMemo, useState } from "react";
import { Badge, Button, Card, Col, Dropdown, DropdownButton, Pagination, Row } from "react-bootstrap";
import ex1 from "../assets/images/ex1.png";
import { BiMessageDetail } from "react-icons/bi";
import { BsThreeDotsVertical } from "react-icons/bs";
import { Link } from "react-router-dom";

const MOCK_RESULTS = [
  {
    id: 1,
    title:
      "Lifestyle Habits That Significantly Reduce Risk of Heart Disease",
    author: {
      image: ex1,
      name: "Jennifer Adams"
    },
    date: "26th Aug, 25",
    description: "Members can share evidence-based tips and personal experiences on diet, exercise, and stress management that lower cardiovascular risk.",
    image: ex1,
    category: "Cardiology"
  },
  {
    id: 2,
    title:
      "Lifestyle Habits That Significantly Reduce Risk of Heart Disease",
    author: {
      image: ex1,
      name: "Jennifer Adams"
    },
    date: "26th Aug, 25",
    description: "Members can share evidence-based tips and personal experiences on diet, exercise, and stress management that lower cardiovascular risk.",
    image: ex1,
    category: "Cardiology"
  },
  {
    id: 3,
    title:
      "Lifestyle Habits That Significantly Reduce Risk of Heart Disease",
    author: {
      image: ex1,
      name: "Jennifer Adams"
    },
    date: "26th Aug, 25",
    description: "Members can share evidence-based tips and personal experiences on diet, exercise, and stress management that lower cardiovascular risk.",
    image: ex1,
    category: "Cardiology"
  },
];
export default function AuthorProfile({ }) {

  const items = ["Wang Q", "Xiao ZX", "Zheng X", "Xiang N", "Schett G"];
  const [currentPage, setCurrentPage] = useState(1);
  const [showFilters, setShowFilters] = useState(false);
  const totalPages = 10;
  const [query, setQuery] = useState("");


  const filtered = useMemo(() => {
    const q = query.trim().toLowerCase();
    if (!q) return MOCK_RESULTS;
    return MOCK_RESULTS.filter((r) =>
      [r.title, r.journal, r.doi, r.pmid, ...(r.authors || [])]
        .join(" ")
        .toLowerCase()
        .includes(q)
    );
  }, [query]);

  const handlePageChange = (page) => {
    if (page < 1 || page > totalPages) return;
    setCurrentPage(page);
  };


  return (
    <>
      <Card className="bio-card">
        <Card.Body>
          <Row>
            <Col lg={5} xs={12} className="col h-100">
              <h3>Bio</h3>
              <p className="mb-0">
                Jennifer Adams is a dedicated health practitioner with over a decade
                of experience in preventive care and patient wellness. She
                specializes in guiding individuals toward healthier lifestyle
                choices through evidence-based nutrition, stress management
                techniques, and personalized fitness plans. Known for her
                approachable style and practical advice, Jennifer focuses on
                empowering patients to take small, consistent steps that lead to
                lasting improvements in overall health. Her passion lies in making
                medical knowledge accessible and actionable for everyday life.
              </p>
            </Col>
            <Col>
              <h3>Interest Tags</h3>
              {
                items?.map((tag, index) => (
                  <Badge key={index} className="tag">
                    {tag}
                  </Badge>
                ))
              }
            </Col>
            <Col className="border-end-0">
              <h3>Total Post</h3>
              <p className="mb-0">204</p>
            </Col>
          </Row>
        </Card.Body>
      </Card>
      <div className="results-stack community-stack profile-stack">
        <h3>Recent Discussions Created</h3>
        {filtered.map((r) => (
          <Card key={r.id} className="result-card community-card">
            <Card.Body>
              <div className="d-flex flex-wrap justify-content-between align-items-center mb-3">
                <div className="category-tag">
                  {/* {r.category.map((l, i) => (
                                <Badge key={i} className="mb-md-0">{l}</Badge>
                              ))} */}
                  <Badge className="mb-md-0">{r.category}</Badge>
                </div>
                <div className="d-flex align-items-center discussion-tag">
                  <BiMessageDetail />
                  5 Discussions
                  <DropdownButton
                    align="end"
                    title={
                      <>
                        <BsThreeDotsVertical />
                      </>
                    }
                    id="dropdown-menu-align-end"
                  >
                    <Dropdown.Item eventKey="1">View Discussion</Dropdown.Item>
                    <Dropdown.Item eventKey="2">View Author Profile</Dropdown.Item>
                  </DropdownButton>
                </div>
              </div>
              <Card.Title className="result-title">
                {r.title}
              </Card.Title>
              <div className="author-chips">
                <span>
                  On {r?.date}
                </span>
              </div>
              <div className="meta-sub">{r.description}</div>
              <div className="mt-2">
                <Button
                  as={Link}
                  to={`/explore/${r.id}`}
                  state={{ item: r }}
                  size="sm"
                  variant="light"
                  className="read-more-btn"
                >
                  VIEW DISCUSSION
                </Button>
              </div>
            </Card.Body>
          </Card>
        ))}
      </div>

      {/* Pagination */}
      <div className="d-flex justify-content-center mt-3">
        <Pagination className="mas-pagination">
          <Pagination.First
            disabled={currentPage === 1}
            onClick={() => handlePageChange(1)}
          />
          <Pagination.Prev
            disabled={currentPage === 1}
            onClick={() => handlePageChange(currentPage - 1)}
          />
          {[1, 2, 3, 4, 5].map((n) => (
            <Pagination.Item
              key={n}
              active={n === currentPage}
              onClick={() => handlePageChange(n)}
            >
              {n}
            </Pagination.Item>
          ))}
          <Pagination.Ellipsis disabled />
          <Pagination.Item onClick={() => handlePageChange(totalPages)}>
            {totalPages}
          </Pagination.Item>
          <Pagination.Next
            disabled={currentPage === totalPages}
            onClick={() => handlePageChange(currentPage + 1)}
          />
          <Pagination.Last
            disabled={currentPage === totalPages}
            onClick={() => handlePageChange(totalPages)}
          />
        </Pagination>
      </div>
    </>
  );
}
